import React from 'react'

export default ({ ...props }) => (
  <svg
    version='1.0'
    xmlns='http://www.w3.org/2000/svg'
    width='680.000000pt'
    height='422.000000pt'
    viewBox='0 0 680.000000 422.000000'
    preserveAspectRatio='xMidYMid meet'
    {...props}
  >
    <g transform='translate(0.000000,422.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>
      <path
        d='M4430 4213 c-314 -23 -682 -105 -1040 -233 -80 -28 -153 -54 -162
 -57 -16 -5 -18 -20 -18 -134 0 -71 2 -129 5 -129 2 0 51 18 107 41 414 165
 915 279 1224 279 l64 0 0 120 0 120 -67 -2 c-38 -1 -88 -3 -113 -5z'
      />
      <path
        d='M2002 4064 l3 -119 125 -7 c113 -6 317 -42 387 -69 13 -5 29 -9 34
 -9 5 0 9 54 9 124 l0 124 -92 21 c-157 35 -209 42 -341 48 l-128 6 3 -119z'
      />
      <path
        d='M4455 3810 c-326 -22 -559 -81 -1120 -280 -102 -37 -131 -43 -200
 -43 -99 -1 -150 14 -376 108 -345 143 -488 178 -734 179 -93 1 -182 -2 -197
 -7 l-28 -7 0 -120 0 -120 48 8 c26 4 112 7 192 6 192 -1 292 -25 601 -149 285
 -115 359 -135 488 -135 116 0 212 22 371 83 534 206 992 282 1383 228 l57 -8
 0 123 0 122 -87 6 c-185 12 -282 14 -398 6z'
      />
      <path
        d='M4430 3404 c-286 -35 -505 -93 -901 -237 -152 -56 -234 -70 -399 -70
 -126 1 -177 6 -385 44 -233 42 -246 43 -445 43 -186 0 -213 -2 -295 -25 l-90
 -24 -3 -127 c-1 -71 0 -128 2 -128 3 0 44 13 93 29 190 64 301 63 673 -1 195
 -33 266 -41 415 -45 216 -6 313 7 485 68 559 199 738 240 1035 240 131 0 303
 -17 368 -37 16 -5 17 3 15 118 l-3 123 -70 13 c-70 12 -428 24 -495 16z'
      />
      <path
        d='M4422 2999 c-177 -21 -330 -65 -792 -228 -202 -71 -286 -85 -515 -85
 -175 0 -217 3 -335 27 -74 14 -172 37 -218 50 l-83 24 3 -125 3 -126 90 -23
 c204 -51 329 -67 535 -67 279 0 415 27 745 152 181 68 324 112 470 144 83 18
 132 22 288 23 l187 0 0 116 0 116 -61 7 c-80 8 -224 6 -317 -5z'
      />
      <path
        d='M4090 2509 c-411 -143 -574 -189 -768 -214 -217 -29 -343 -20 -759
 55 -125 22 -243 43 -260 46 l-33 5 0 -121 c0 -66 2 -120 5 -120 2 0 114 -20
 247 -44 368 -67 390 -70 583 -70 203 -1 312 14 540 71 130 33 570 177 588 193
 4 3 6 61 5 128 l-3 121 -145 -50z'
      />
      <path
        d='M94 1848 c-9 -18 -32 -61 -51 -95 l-35 -63 74 0 73 1 98 94 99 95
 -121 0 -120 0 -17 -32z'
      />
      <path
        d='M5968 1640 c-76 -23 -118 -80 -127 -175 l-6 -60 -42 -3 -43 -3 0 -75
 0 -74 45 0 45 0 0 -255 0 -255 85 0 85 0 0 255 0 255 65 0 65 0 0 75 0 75 -65
 0 -65 0 0 29 c0 45 29 72 83 78 l47 6 0 68 0 69 -72 -1 c-40 0 -85 -4 -100 -9z'
      />
      <path d='M0 1190 l0 -451 93 3 92 3 3 448 2 447 -95 0 -95 0 0 -450z' />
      <path d='M960 1190 l0 -451 88 3 87 3 3 448 2 447 -90 0 -90 0 0 -450z' />
      <path
        d='M3100 1488 l0 -151 -23 21 c-52 49 -161 67 -249 40 -52 -15 -123 -80
 -153 -137 -67 -132 -51 -329 36 -434 85 -104 242 -127 352 -53 l36 25 3 -27
 c3 -27 3 -27 88 -27 l85 0 3 448 2 447 -90 0 -90 0 0 -152z m-64 -247 c47 -29
 69 -83 69 -171 -1 -87 -20 -130 -76 -168 -76 -52 -182 -4 -209 94 -27 95 6
 215 68 249 38 20 111 19 148 -4z'
      />
      <path
        d='M4690 1495 l0 -95 -45 0 -45 0 0 -75 0 -75 45 0 45 0 0 -197 c0 -218
 6 -245 63 -287 24 -18 46 -22 138 -24 l109 -4 0 76 0 76 -54 0 c-82 0 -86 9
 -86 202 l0 158 65 0 65 0 0 75 0 75 -65 0 -65 0 0 95 0 95 -85 0 -85 0 0 -95z'
      />
      <path
        d='M464 1396 c-100 -31 -160 -115 -152 -212 8 -94 62 -140 198 -169 182
 -38 214 -62 155 -120 -48 -49 -186 -25 -258 43 l-28 26 -56 -56 -56 -56 29
 -27 c83 -77 246 -114 374 -84 169 39 247 222 141 328 -38 38 -111 65 -242 91
 -69 13 -97 39 -81 74 27 60 151 54 223 -11 l39 -35 47 53 c27 29 48 57 48 63
 0 18 -93 75 -148 91 -61 18 -177 19 -233 1z'
      />
      <path
        d='M1440 1401 c-74 -24 -148 -88 -174 -152 l-15 -36 82 -17 c59 -12 83
 -13 86 -5 11 34 58 71 97 76 69 9 130 -40 111 -90 -3 -7 -55 -22 -122 -35
 -179 -34 -252 -84 -269 -184 -21 -118 83 -228 215 -228 52 0 128 21 164 46
 l35 24 21 -21 c29 -29 62 -39 130 -39 l59 0 0 63 c0 55 -3 63 -22 72 -22 10
 -23 15 -28 195 -5 173 -7 188 -30 230 -16 28 -42 55 -74 74 -44 28 -57 31
 -145 33 -53 1 -107 -1 -121 -6z m190 -410 c0 -38 -6 -56 -25 -79 -38 -46 -123
 -59 -171 -27 -20 13 -25 23 -22 52 4 47 34 69 118 87 103 22 100 23 100 -33z'
      />
      <path
        d='M2225 1398 c-16 -6 -45 -21 -62 -35 l-33 -24 0 30 0 31 -85 0 -85 0
 0 -330 0 -330 85 0 85 0 0 200 c0 148 4 209 14 234 41 98 171 104 207 9 5 -13
 9 -119 9 -234 l0 -209 86 0 85 0 -3 269 -3 269 -30 44 c-41 59 -101 88 -180
 87 -33 0 -73 -5 -90 -11z'
      />
      <path
        d='M3541 1393 c-59 -21 -128 -90 -137 -138 -12 -66 0 -133 31 -165 39
 -40 80 -58 193 -82 117 -24 142 -38 142 -78 0 -38 -40 -60 -110 -60 -63 0
 -115 21 -160 65 l-36 35 -53 -54 c-34 -34 -52 -60 -48 -69 9 -24 88 -74 148
 -94 82 -28 228 -25 294 5 96 44 137 102 137 193 0 111 -58 159 -241 199 -125
 27 -160 60 -110 106 44 39 170 14 223 -45 l20 -22 48 48 c26 26 48 55 48 64 0
 23 -81 76 -144 94 -64 19 -188 18 -245 -2z'
      />
      <path
        d='M4177 1396 c-63 -23 -106 -59 -132 -110 -31 -62 -32 -109 -2 -166 28
 -58 73 -82 198 -109 130 -28 147 -35 155 -67 6 -22 2 -32 -20 -51 -53 -45
 -174 -26 -254 42 l-33 28 -55 -54 -55 -54 41 -37 c67 -60 136 -82 261 -82 98
 -1 109 1 164 29 125 64 165 207 85 299 -34 38 -79 57 -203 86 -114 26 -127 33
 -127 71 0 25 6 33 36 45 59 25 135 6 202 -51 l30 -25 47 55 c53 62 52 68 -15
 110 -85 53 -235 72 -323 41z'
      />
      <path
        d='M5290 1401 c-139 -43 -221 -162 -222 -322 -1 -149 57 -258 167 -314
 53 -27 68 -30 149 -30 73 0 101 5 142 23 122 55 194 193 181 347 -12 147 -83
 246 -209 291 -43 15 -166 18 -208 5z m160 -150 c20 -11 44 -36 58 -62 20 -38
 23 -55 20 -131 -2 -68 -7 -92 -24 -114 -36 -48 -67 -66 -119 -66 -86 0 -135
 59 -143 171 -7 104 26 178 92 207 43 18 75 17 116 -5z'
      />
      <path
        d='M6367 1396 c-81 -30 -138 -84 -166 -157 l-10 -26 82 -17 c59 -12 83
 -13 86 -5 10 30 59 70 91 75 70 11 136 -39 117 -89 -3 -7 -54 -22 -121 -35
 -176 -33 -242 -74 -267 -165 -42 -155 102 -275 284 -237 31 6 72 22 92 35 l35
 25 21 -21 c29 -29 62 -39 130 -39 l59 0 0 65 c0 45 -4 65 -12 65 -40 1 -43 14
 -48 213 -5 189 -6 194 -32 234 -40 61 -102 87 -213 91 -58 1 -103 -3 -128 -12z
 m203 -404 c0 -78 -50 -124 -137 -124 -65 0 -101 39 -82 89 11 31 46 51 120 67
 101 22 99 23 99 -32z'
      />
      <path
        d='M960 255 l0 -245 130 0 c144 0 183 10 218 55 17 21 22 41 22 82 0 49
 -4 59 -33 88 l-34 34 26 26 c22 21 26 35 26 79 0 100 -47 126 -230 126 l-125
 0 0 -245z m256 153 c24 -23 21 -68 -6 -90 -17 -13 -40 -18 -91 -18 l-69 0 0
 66 0 66 75 -4 c52 -2 80 -8 91 -20z m11 -210 c28 -26 29 -58 4 -89 -17 -21
 -30 -24 -100 -27 l-81 -4 0 71 0 71 77 0 c65 0 80 -3 100 -22z'
      />
      <path d='M2100 460 l0 -40 40 0 40 0 0 40 0 40 -40 0 -40 0 0 -40z' />
      <path d='M3820 255 l0 -245 45 0 45 0 0 245 0 245 -45 0 -45 0 0 -245z' />
      <path d='M4700 255 l0 -245 45 0 45 0 0 245 0 245 -45 0 -45 0 0 -245z' />
      <path
        d='M5840 421 l0 -80 -46 20 c-94 42 -190 -11 -212 -118 -36 -166 88
 -292 221 -224 29 15 37 16 37 5 0 -10 12 -14 40 -14 l40 0 0 245 0 245 -40 0
 -40 0 0 -79z m-30 -146 c30 -32 39 -109 17 -152 -22 -41 -67 -60 -107 -43 -63
 26 -82 132 -34 189 34 41 89 43 124 6z'
      />
      <path
        d='M1835 365 c-54 -19 -75 -48 -75 -100 0 -63 22 -84 110 -104 79 -19
 103 -38 84 -69 -18 -29 -83 -27 -127 3 -39 26 -59 24 -86 -8 -9 -12 -6 -20 19
 -40 55 -47 139 -59 209 -31 49 19 74 55 74 108 0 48 -32 80 -96 96 -23 6 -55
 14 -72 18 -35 9 -45 40 -19 59 27 20 57 16 99 -13 l38 -25 25 25 c22 21 24 27
 12 41 -36 44 -131 63 -195 40z'
      />
      <path
        d='M2378 362 c-30 -16 -38 -17 -38 -6 0 10 -13 14 -45 14 l-45 0 0 -180
 0 -180 45 0 45 0 0 124 c0 123 0 125 26 145 34 27 66 27 90 0 16 -18 20 -40
 23 -145 l3 -124 39 0 39 0 0 130 c0 143 -11 187 -53 215 -40 26 -87 29 -129 7z'
      />
      <path
        d='M2727 366 c-50 -18 -76 -42 -98 -91 -43 -94 -11 -209 71 -252 76 -40
 161 -26 213 36 31 37 29 45 -12 59 -25 9 -32 7 -50 -14 -27 -31 -64 -39 -102
 -24 -27 12 -59 54 -59 80 0 6 45 10 126 10 l126 0 -4 54 c-5 56 -38 115 -77
 136 -34 17 -95 20 -134 6z m86 -67 c25 -11 51 -52 40 -63 -4 -3 -39 -6 -80 -6
 -53 0 -73 3 -73 13 0 17 20 42 45 55 26 14 38 15 68 1z'
      />
      <path
        d='M3074 369 c-52 -15 -84 -55 -84 -105 0 -67 17 -80 156 -114 48 -12
 62 -35 38 -61 -25 -28 -83 -24 -128 6 l-37 25 -31 -22 -31 -21 31 -28 c58 -52
 176 -63 238 -22 28 18 54 68 54 102 0 37 -46 78 -103 91 -81 18 -107 30 -107
 51 0 44 83 49 127 7 l24 -22 27 28 27 27 -28 24 c-45 40 -110 52 -173 34z'
      />
      <path
        d='M3405 365 c-54 -19 -75 -48 -75 -100 0 -63 22 -84 110 -104 79 -19
 103 -38 84 -69 -18 -29 -83 -27 -127 3 -39 26 -59 24 -86 -8 -9 -12 -6 -20 19
 -40 59 -50 149 -60 220 -25 36 19 47 31 58 64 24 77 -9 114 -125 143 -73 17
 -93 42 -57 68 27 20 57 16 99 -13 l38 -25 25 25 c22 21 24 27 12 41 -36 44
 -131 63 -195 40z'
      />
      <path
        d='M4095 371 c-122 -31 -172 -193 -92 -305 24 -33 89 -65 134 -66 48 0
 110 28 133 60 27 38 25 47 -11 66 -26 13 -33 14 -40 2 -5 -7 -9 -16 -9 -21 0
 -4 -15 -15 -34 -24 -68 -32 -126 20 -126 111 0 36 6 52 28 78 40 43 84 43 124
 -1 27 -31 29 -31 58 -16 34 18 34 16 18 50 -23 51 -114 84 -183 66z'
      />
      <path
        d='M4439 371 c-44 -14 -74 -39 -98 -82 -32 -56 -28 -167 8 -218 28 -39
 91 -71 141 -71 64 0 150 55 150 95 0 6 -14 16 -30 22 -27 10 -33 9 -59 -18
 -40 -39 -82 -39 -122 0 -16 16 -29 39 -29 50 0 20 5 21 126 21 l127 0 -6 51
 c-7 60 -38 114 -77 134 -36 19 -98 26 -131 16z m104 -88 c9 -9 17 -24 17 -35
 0 -16 -9 -18 -80 -18 -44 0 -80 3 -80 8 0 15 33 54 54 62 26 11 65 4 89 -17z'
      />
      <path
        d='M4944 370 c-30 -10 -94 -70 -94 -90 0 -5 16 -14 36 -19 33 -9 39 -8
 56 14 23 29 77 34 102 9 30 -29 18 -40 -66 -58 -103 -22 -138 -52 -138 -118 0
 -36 6 -50 30 -73 39 -37 109 -45 162 -17 32 17 39 17 49 6 6 -8 29 -14 50 -14
 36 0 39 2 39 29 0 16 -6 31 -15 35 -12 4 -15 26 -15 108 0 110 -9 139 -50 169
 -30 23 -103 32 -146 19z m116 -220 c0 -42 -39 -80 -83 -80 -54 0 -76 40 -39
 73 14 12 68 29 115 36 4 1 7 -13 7 -29z'
      />
      <path
        d='M5365 373 c-10 -3 -29 -12 -42 -20 -21 -14 -23 -14 -23 1 0 12 -10
 16 -40 16 l-40 0 0 -180 0 -180 39 0 39 0 4 126 c3 118 4 127 27 145 30 25 66
 24 91 -1 18 -18 20 -33 20 -145 l0 -125 40 0 40 0 0 140 c0 161 -10 193 -65
 216 -35 14 -54 16 -90 7z'
      />
      <path
        d='M1390 230 c0 -157 9 -189 60 -215 40 -21 89 -19 128 5 26 16 32 17
 32 5 0 -11 11 -15 40 -15 l40 0 0 180 0 180 -40 0 -40 0 0 -119 c0 -105 -2
 -121 -21 -145 -15 -19 -30 -26 -54 -26 -56 0 -65 24 -65 167 l0 123 -40 0 -40
 0 0 -140z'
      />
      <path d='M2100 190 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z' />
    </g>
  </svg>
)
